/**
 * 中英文站旧展会列表 URL 的 CSR 兜底。
 * 首屏 SSR：server/middleware/00-fairListLegacyGuardAndRedirect.ts（410/301 + target guard）。
 *
 * 禁止在此无条件 301：预发曾出现 SSR 已 FairListLegacyBiz 410，hydration 时本 middleware
 * 再 301 到语义 URL。须先识别 SSR 错误。
 */
import { getLanguageByHost } from '~/utils/language-detection'

/** 旧链业务不可达（410；兼容历史 404 payload） */
function isFairListLegacyBizGone(err: { statusCode?: number; statusMessage?: string } | null | undefined): boolean {
  const code = err?.statusCode
  if (code !== 410 && code !== 404) return false
  return String(err?.statusMessage ?? '').startsWith('FairListLegacyBiz-')
}

export default defineNuxtRouteMiddleware(async to => {
  if (import.meta.server) return

  // SSR 已判定旧链 410：hydration 期间 router.replace 会再跑 global middleware，此处必须短路
  if (isFairListLegacyBizGone(useError().value)) return

  const siteLang = getLanguageByHost(window.location.host.split(':')[0])
  if (siteLang !== 'cn' && siteLang !== 'en') return

  const { isLegacyFairListPathNeeding301 } = await import('~/utils/fairListLegacyPath')
  if (!isLegacyFairListPathNeeding301(to.path)) return

  // CSR 旧链 301 不在客户端做（缺 dimension/biz guard，会与 SSR 决策不一致）。
  // 全页刷新走 Nitro；站内 SPA 切到旧链暂保留 legacy 路由渲染。
})
